export default "__VITE_ASSET__B_$Wj_Nf__"